import { Component, OnInit } from '@angular/core';
import { faLifeRing, faCommentSmile, faEnvelope, faQuestion } from '@fortawesome/pro-solid-svg-icons';
import packageJson from '../../../../../package.json';
import { TranslateModule } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'app-hero-footer',
  templateUrl: './hero-footer.component.html',
  styleUrls: ['./hero-footer.component.scss'],
  imports: [FaIconComponent, TranslateModule],
})
export class HeroFooterComponent {
  faLifeRing = faLifeRing;
  faQuestion = faQuestion;
  faEnvelope = faEnvelope;
  faCommentSmile = faCommentSmile;
  appVersion: any;
  constructor() {
    this.appVersion = packageJson.version;
  }
}
